// extracted by mini-css-extract-plugin
export default {"wechatBind":"wechatBind_snYts","banner":"banner_Z7b4e"};